import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RedeemWindow } from '../services/redeem-window';

export const redirectToShowCodeGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const redeemWindow = inject(RedeemWindow);

  await redeemWindow.ready;

  if (redeemWindow.hasActiveWindow()) {
    const merchantName = redeemWindow.getMerchantName();
    if (merchantName) {
      return router.createUrlTree(['/showcode', merchantName]);
    }
    // legacy/incomplete state saved before merchantName was tracked — clear it and stay put
    redeemWindow.clear();
  }
  return true;
};
